import React from "react";
import VendorCard from "./VendorCard";

export default function JobCard({ firstName, profilePhoto, lastName, company, id, job }) {
  return (
    <div className="flex flex-col bg-white p-4 rounded-lg space-y-3">
      <div className="flex flex-row space-x-2">
        <span className="font-medium">Title:</span>
        <span>{job?.title}</span>
      </div>
      <div className="flex flex-row space-x-4">
        <span className="font-medium">Description:</span>
        <span>{job?.description}</span>
      </div>
      <div className="flex flex-row space-x-4">
        <span className="font-medium">Skills:</span>
        <span className="flex flex-row space-x-2">
          {job?.main_skill?.length > 0 &&
            job?.main_skill?.map((skill) => {
              return (
                <span
                  style={{
                    height: "25px",
                    color: "#139588",
                    border: "1px solid #139588",
                  }}
                  className="text-justify text-sm py-0.5 px-1"
                >
                  {skill}
                </span>
              );
            })}
          {!job?.main_skill && "No Skills Provided"}
        </span>
      </div>
      <div className="flex flex-row justify-between">
        <div className="flex flex-row space-x-2">
          <span className="font-medium">Location:</span>
          <span>{job?.location}</span>
        </div>
        <div className="flex flex-row space-x-2">
          <span className="font-medium">Start Date:</span>
          <span>{job?.startDate}</span>
        </div>
        {job?.hourlyRate ? (
          <div className="flex flex-row space-x-2">
            <span className="font-medium">Hourly Rate:</span>
            <span>{job?.hourlyRate}</span>
          </div>
        ) : <div className="flex flex-row space-x-2" />}
      </div>
      {/* <div>
        <VendorCard firstName={firstName} profilePhoto={profilePhoto} company={company} lastName={lastName} id={id} />
      </div> */}
    </div>
  );
}
